/**
 * 홈페이지 API 서비스
 */
import { apiClient } from '../../../core/api/client';
import { 
  HomePageDeliveryCountResponse, 
  HomePageDeliveryCountRequest 
} from '../types/homePage';

const BASE_PATH = '/api/v1/mob/homepage';

/**
 * 홈페이지 배송 건수 조회
 * GET /api/v1/mob/homepage/delivery-list
 */
export const getHomePageDeliveryList = async (
  params: HomePageDeliveryCountRequest
): Promise<HomePageDeliveryCountResponse> => {
  const adminViewRiderId = localStorage.getItem('ADMIN_VIEW_RIDER_ID');
  const requestParams = adminViewRiderId 
    ? { ...params, riderId: adminViewRiderId }
    : params;
    
  const response = await apiClient.get<HomePageDeliveryCountResponse>(
    `${BASE_PATH}/home-delivery-list`,
    { params: requestParams }
  );
  return response.data;
};

